import React from "react";
import { cn } from "@/lib/utils";
import { STATUS_META, PRIORITY_META, HEALTH_META, WORKLOAD_META } from "@/lib/format";

export function StatusBadge({ status, className }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span data-testid="task-status-badge"
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", m.cls, className)}>
      {m.label}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const m = PRIORITY_META[priority] || PRIORITY_META.normal;
  return <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold", m.cls)}>{m.label}</span>;
}

export function HealthBadge({ health }) {
  const m = HEALTH_META[health] || HEALTH_META.on_track;
  return <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold", m.cls)}>{m.label}</span>;
}

export function WorkloadBadge({ level, utilization }) {
  const m = WORKLOAD_META[level] || WORKLOAD_META.optimal;
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold", m.cls)}>
      {utilization != null ? `${utilization}% · ` : ""}{m.label}
    </span>
  );
}
